export default "__VITE_ASSET__DRFy3BMZ__"